import * as actionTypes from './../actions/feedingGuidelinesBodyConditionAction';

const initialState = {
  data: {},
  pending: true,
  error: null,
  ready: false,
};

const reducer = ( state = initialState, action ) => {
  switch ( action.type ) {
    case actionTypes.FETCH_DATA_PENDING:
      return {
        ...state,
        pending: true
      };
    case actionTypes.FETCH_DATA_SUCCESS:
      return {
        ...state,
        pending: false,
        ready: true,
        data: action.data,
      };
    case actionTypes.FETCH_DATA_ERROR:
      return {
        ...state,
        pending: false,
        error: action.error
      };
    default:
      return state;
  }
};

export default reducer;
